<template>
    <div class="aa">
        <!-- 答题卡 -->
        <div class="toggle-button" :class="{toggle_button_z:isExpanded , sysiosbutton: sysios}" @click="toggleExpand">
            <i v-if="isExpanded" :class="isExpanded ? 'el-icon-arrow-left' : 'el-icon-arrow-right'"></i>
            <span v-if="!isExpanded" class="vertical-text">答题卡</span>
        </div>
        <div class="scantron" :class="{ expanded: isExpanded , sysios: sysios && isExpanded}">
            
            <el-card v-for="(item,index) in list" :key="index" shadow="never" class="box-card">
                <div slot="header" class="clearfix">
                    <span style="font-size: 14px;font-weight: 700;">{{ item.name }}</span>
                    <div style="float: right;font-size: 14px;opacity: 0.8;">共 {{ totalProperties(index) }} 小题 / <span style="color: red;">总分 {{ fraction_data[index] }}</span></div>
                </div>
                <div class="question_card">
                    <div v-for="(question_item,question_index,ou_index) in item.items" :key="ou_index" class="question_number">
                    
                        <span style="font-size: 14px;font-weight: 700;float: left;">({{ ou_index+1 }})</span>

                        <!-- <span v-show="['6','7'].includes(question_item.type)" :class="['item',{ question_active: question_item.answer}]">1</span> -->

                        <div v-if="['6','7'].includes(question_item.type)">
                        
                            <span v-if="!setWrite(index,question_index)" class="item">1</span>
                            <span style="background: none;" v-if="setWrite(index,question_index)" class="item"><i style="font-size: 24px;" class="el-icon-success"></i></span>
                            
                        </div>

                        <!-- 单词变形 -->
                        <div v-if="question_item.type == '5'">
                            <span v-for="(d_item,d_index) in question_item.answer" :key="d_index">
                                <span style="float: left;" v-if="!set(index,question_index,d_index)" class="item">{{ d_index+1 }}</span>
                                <span style="float: left;background: none;" v-if="set(index,question_index,d_index)" class="item"><i style="font-size: 24px;" class="el-icon-success"></i></span>
                            </span>
                        </div>
                        
                        <!-- 匹配题 -->
                        <div v-if="question_item.type == '4'">
                            <span v-for="(a_item,r_index) in question_item.answer" :key="r_index" :class="['item',{ question_active: set(index,question_index,r_index)}]">{{ (() => { const result = set(index, question_index, r_index); return result? result : r_index + 1; })() }}</span>
                        </div>
                        <!-- 单选 -->
                        <span v-show="!question_item.type" v-for="(a_item,a_index,b_index) in question_item" :key="a_index" :class="['item',{ question_active: a_item || set(index,question_index,a_index)}]">{{ a_item?a_item:(set(index,question_index,a_index)?set(index,question_index,a_index):b_index+1) }}</span>
                    </div>
                </div>
            </el-card>
            <div class="button_box">
                <el-button @click="open" v-if="show" type="primary">提交试卷</el-button>
            </div>
            <!-- <el-button @click="open" v-if="show" type="primary">提交试卷</el-button> -->
        </div>
    </div>
    
</template>
<script>
import Http from "../../apis/student";
export default {
    name:'Scantron',
    props:{
        nid:[Number, String]
    },
    data(){
        return{
            list:{},
            answer_data:{},
            type_data:{},
            show:false,
            fraction_data:{},
            sub_time:0,
            sub_time_obj:null,
            isExpanded: false,
            articl_data:{},
            sysios:false
        }
    },

    watch:{

    },
    mounted(){
        
    },
    created(){
        if(/iPad|iPhone|iPod/.test(navigator.userAgent) || 
           (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)){
            this.sysios = true
        }

    },

    methods:{

        toggleExpand() {
 
            this.isExpanded = !this.isExpanded;
        },
        // 统计小题数量
        totalProperties(index) {
            var data = this.list
            var row = data[index].items
            var number = 0;
            if(['1','2','3','9'].includes(index)){
                for(var i in row){
                    number += Object.keys(row[i]).length
                    
                }
            }
            if(['4','5'].includes(index)){
                for(var i in row){
                    number += row[i].answer.length
                }
            }
            if(['6','7'].includes(index)){
                for(var i in row){
                    number += 1
                }
            }
            return number
        },

        setData(data,type_data,fraction_data){
            this.fraction_data = fraction_data
            this.show = true
            this.type_data = type_data
            let restructuredData = {};
            this.articl_data = data
            for (let typeKey in data) {
                let typeName = this.type_data[typeKey];
                
                if(['4','5'].includes(typeKey)){
                    
                    restructuredData[typeKey] = {
                        "name": typeName,
                        "items": data[typeKey]
                    };
                    var row = data[typeKey]
                    for(var index in row){
                        
                        for(var i in row[index].answer){

                            restructuredData[typeKey].items[index]['answer'][i] = "";
                        }
                    }
                    //console.log('答题卡',restructuredData)
                }else if(['6','7'].includes(typeKey)){
                    restructuredData[typeKey] = {
                        "name": typeName,
                        "items": data[typeKey]
                    };
                    var row = data[typeKey]
                    
                    for(var index in row){
                        restructuredData[typeKey].items[index]['answer'] = "";
                        
                    }
                }else{
                    restructuredData[typeKey] = {
                        "name": typeName,
                        "items": {}
                    };
                    for (let itemKey in data[typeKey]) {
                        restructuredData[typeKey].items[itemKey] = {};
                        let testData = data[typeKey][itemKey].test;
                        for (let questionKey in testData) {
                            restructuredData[typeKey].items[itemKey][questionKey] = "";
                        }
                    }
                }
                
            }
            
            this.list = restructuredData

        },
        // 选择题类型 标记答题卡
        changeLable(aid,qid,question_type,answer){
            
            this.list[question_type].items[aid][qid] = answer

        },

        // 匹配、单词变形 标记答题卡
        changeLablePipei(aid, qid, question_type, subanswer) {
  
            
            this.list[question_type].items[aid].answer[qid] = subanswer
            // 强制更新组件
            this.$forceUpdate();

        },
        changeLableWrite(aid, question_type, subanswer){
            this.list[question_type].items[aid].answer = subanswer
        },


        // 切换题型或材料保持标记答题卡
        changQuestionCard(data) {

            //console.log('答案',localStorage.getItem('answer_result'));
            
            if (localStorage.getItem('answer_result') && Object.keys(JSON.parse(localStorage.getItem('answer_result'))).length) {

                var result = JSON.parse(localStorage.getItem('answer_result'));
                
                var row = this.deepMerge(result,data)

                localStorage.setItem('answer_result', JSON.stringify(row));

                this.$set(this, 'answer_data', { ...JSON.parse(localStorage.getItem('answer_result')) });
                return false;
                
            } else {
                this.$set(this, 'answer_data', { ...data });
            }

            try {
                localStorage.setItem('answer_result', JSON.stringify(data));
            } catch (error) {
                console.error('序列化数据并存储到 localStorage 时出错:', error);
            }
        },

        // 重新构建答案
        deepMerge(a, b) {
            for (const key in b) {
                if (b.hasOwnProperty(key)) {
                    // 如果a中存在当前键
                    if (a.hasOwnProperty(key)) {
                        const aVal = a[key];
                        const bVal = b[key];

                        // 双方值均为对象时递归合并
                        if (typeof aVal === 'object' && aVal !== null &&
                        typeof bVal === 'object' && bVal !== null) {
                            this.deepMerge(aVal, bVal);
                        } else {
                            a[key] = bVal;
                        }
                    } else {
                        a[key] = b[key];
                    }
                }
            }
            return a;
        },

        set(localQuestionType,question_index,test_index) {
            if (this.answer_data && localQuestionType && question_index && 
                this.answer_data[localQuestionType] && 
                this.answer_data[localQuestionType][question_index] && this.answer_data[localQuestionType][question_index][test_index]) {
                return this.answer_data[localQuestionType][question_index][test_index];
            }
            return false;
        },
        // 写作答案
        setWrite(localQuestionType,question_index) {
            if (this.answer_data && localQuestionType && question_index && 
                this.answer_data[localQuestionType] && 
                this.answer_data[localQuestionType][question_index]) {
                return this.answer_data[localQuestionType][question_index].answer;
            }
            return false;
        },

        open() {
            this.isExpanded = false;
            this.$confirm('提交答案之前请确保试卷已全部完成，提交后不可修改，可参照右侧答题卡检查完成情况，是否确认交卷?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.submit()
            }).catch((e) => {

                this.$message({
                    type: 'info',
                    message: '取消提交试卷'
                });
            });
        },


        // 提交
        submit() {
            // 判断 sub_time 是否不等于 0，如果是则不允许提交
            if (this.sub_time !== 0) {

                this.$alert(`请不要频繁提交，请在 ${this.sub_time} 秒后再次操作，重复操作还是不能提交请联系老师补考`, '提示', {
                    confirmButtonText: '确定',
                    callback: action => {
                        this.$message({
                            type: 'error',
                            message: '请不要频繁提交'
                        });
                    }
                })
                return;
            }
            
            // 调用检查函数
            const result =this.checkAnswerCompleteness(this.answer_data, this.articl_data);
   
            if (result.isComplete) {
                console.log('答案完整，可以提交');
            } else {
                if (result.missingQuestionTypes.length > 0) {

                    const missingQuestionTypesArr = result.missingQuestionTypes.map(type => 
                        this.type_data[type] || `未知题型(${type})`
                    );
                    if (missingQuestionTypesArr.length > 0) {
                        this.$message({
                            type: 'error',
                            message: `试卷提交失败，题型答案缺失: 【 ${missingQuestionTypesArr.join('、')} 】`
                        })
                        return false;
                    }
    
                }
                // 答案缺失小题详情
                // if (result.incompleteQuestions.length > 0) {

                //     result.incompleteQuestions.forEach(item => {
                //         if (item.question) {
                //             this.$message({
                //                 type: 'error',
                //                 message: `- 题型 ${this.type_data[item.type]} 材料 ${item.material} 小题 ${item.question}: ${item.reason}`
                //             })
                //         } else {
                //             this.$message({
                //                 type: 'error',
                //                 message: `- 题型 ${this.type_data[item.type]} 材料 ${item.material}: ${item.reason}`
                //             })
                //         }
                //     });
                // }
            }

            // 先重置 sub_time 为初始值
            this.sub_time = 20;
            // 再调用倒计时函数
            this.downSubtime();
            var params = {}
            params.post_data = this.answer_data
            params.nid = this.nid
            Http.answer(params).then((res) => {
                this.$message({
                    type: res.code?'success':'error',
                    message: res.msg
                });
                if(res.code){
                    // setTimeout(()=>{
                    //     localStorage.removeItem('answer_result');
                    //     this.$router.go(-1);
                    // },500)
                }
                
            });
        },

        checkAnswerCompleteness(answerData, questionData) {
            // 检查顶级题型是否完整
            const missingQuestionTypes = [];
            const incompleteQuestions = [];
            
            // 遍历所有题型
            for (const [questionType, questions] of Object.entries(questionData)) {
                if (!answerData[questionType]) {
                    missingQuestionTypes.push(questionType);
                    continue;
                }
                
                // 遍历该题型下的所有材料/题目组
                for (const [materialId, materialData] of Object.entries(questions)) {
                    if (!answerData[questionType][materialId]) {
                        incompleteQuestions.push({
                            type: questionType,
                            material: materialId,
                            reason: '整个材料缺失答案'
                        });
                        continue;
                    }
                    
                    // 对于选择题型(1,2,3,9)
                    if ([1, 2, 3, 9].includes(parseInt(questionType))) {
                        const testQuestions = materialData.test;
                        const answerQuestions = answerData[questionType][materialId];
                        
                        // 检查每个小题是否有答案
                        for (const [questionId, question] of Object.entries(testQuestions)) {
                            if (answerQuestions[questionId] === undefined) {
                                incompleteQuestions.push({
                                    type: questionType,
                                    material: materialId,
                                    question: questionId,
                                    reason: '小题答案缺失'
                                });
                            }
                        }
                    }
                    // 对于写作和翻译题型(6,7)
                    else if ([6, 7].includes(parseInt(questionType))) {
                        const answer = answerData[questionType][materialId].answer;
                        if (!answer || answer.trim() === '') {
                            incompleteQuestions.push({
                                type: questionType,
                                material: materialId,
                                reason: '主观题答案为空'
                            });
                        }
                    }
                }
            }
            
            return {
                isComplete: missingQuestionTypes.length === 0 && incompleteQuestions.length === 0,
                missingQuestionTypes,
                incompleteQuestions
            };
        },



        downSubtime() {
            if (this.sub_time > 0) {
                if (!this.sub_time_obj) {
                    this.sub_time_obj = setInterval(() => {
                        this.sub_time--;
                        if (this.sub_time <= 0) {
                            clearInterval(this.sub_time_obj);
                            this.sub_time_obj = null;
                        }
                        this.downSubtime()
                    }, 1000);
                }
            } else {
                if (this.sub_time_obj) {
                    clearInterval(this.sub_time_obj);
                    this.sub_time_obj = null;
                }
            }
        }
    }
}
</script>
<style lang="less" scoped>

.toggle-button{
    display: none;
}
.box-card{
    margin-bottom: 10px;
}
.question_card{
    width: 100%;
    display: inline-block;
}
.question_number{

    span{
        display: inline-block;
        margin-right: 10px;
        line-height: 25px;
        margin-bottom: 15px;
        width: 25px;
        height: 25px;
    }
    .item{
        
        color: #409EFF;
        background: #ecf5ff;
        border-color: #b3d8ff;
        border-radius: 50px;
        text-align: center;
        font-size: 14px;
    }
}
.scantron::v-deep .el-card__header{
    padding: 7px 13px;
}
.scantron::v-deep .el-card__body{
    padding: 14px;
}
.question_active{
    background-color: #409EFF !important;
    color: #ffffff !important;
}
.scantron{
    height: 100%;
    position: relative;
    
}
.button_box{
    width: 100%;
    position: sticky;
    bottom: 0;
    left: 0;
    background: #ffffff;
    padding-bottom: 20px;
}
.button_box::v-deep .el-button{
    width: 80%;
    margin-left: 10%;
}
.scantron::v-deep .el-card__header{
    background: #F6F7FB;
}
@media (max-width: 768px) {

    .scantron {
        position: fixed;
        left: -261px;
        top: 50%;
        transform: translateY(-50%);
        width: 261px; 
        background-color: #fff;
        box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);
        transition: left 0.3s ease; 
        z-index: 99999;
        overflow: auto;

        &.sysios {
            left: 50%;
            height: 70%;
            transform: translate(-50%, -50%);
            overflow: auto;
        }
    }

    .scantron.expanded {
        left: 0; /* 展开状态 */
        
        &.sysios {
            left: 50%;
            height: 70%;
            overflow: auto;
        }
    }

    .toggle-button {
        position: fixed;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 30px;
        height: 60px;
        background-color: #409EFF;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        border-radius: 0 4px 4px 0;
        box-shadow: 2px 0 4px rgba(0, 0, 0, 0.1);
        z-index: 10;
        transition: left 0.3s ease;

        &.sysiosbutton {
            left: 10%;
        }
    }

    .toggle_button_z {
        left: 261px; 
    }

    .toggle-button i{
        font-size: 18px;
    }

    .scantron .box-card {
        width: 100%;
        height: auto;
        margin-bottom: 10px;
        padding: 10px;
        box-sizing: border-box;
    }

    .scantron .question_card {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
    }

    .scantron .question_number {
        font-size: 12px;
        margin-bottom: 10px;
    }
    .vertical-text {
        writing-mode: vertical-rl;
        text-orientation: upright;
        font-size: 14px;
        padding: 4px 2px;
 
    }
}
</style>